import { useAppConstantsContext } from '@/context/AppConstants';
import { SearchFormProps } from '@/reports/index';
import { RecentReportsSuggestions } from '@/reports/shared/RecentReportsSuggestions/RecentReportsSuggestions';
import { FcraWarning } from '@/reports/shared/searchFormsComponents/components';
import { Stack } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';
import { VehicleSearchForm } from '../VehicleSearchForm';

/**
 * This component is responsible for providing users with the ability to search for vehicles.
 * The searches can be performed by VIN, license plate or year, make and model.
 */
export function HeaderVehicleSearch({
  onSuccess,
  onError,
  closeForm,
  claimReport = false,
  placement = 'header',
}: SearchFormProps) {
  const {
    links: { tosLink, fcraLink },
    data: { brandName },
  } = useAppConstantsContext();
  const { isMobile } = useScreenSize();
  const isInHeader = placement === 'header';
  const isInDashboard = placement === 'dashboard';
  const StackMargin = isInDashboard ? '0px' : '0px 10px';
  const FormMargin = isInDashboard ? '0px 10px' : '0px';

  return (
    <Stack margin={StackMargin}>
      <VehicleSearchForm
        onSuccess={onSuccess}
        onError={onError}
        claimReport={claimReport}
        vinInformationOptions
        clearFields={false}
        searchButtonText="Search"
        placement={placement}
        mobileView={isMobile}
        isDashboardSearchHub={isInDashboard}
        optionalProps={{
          vinLabelHidden: isInDashboard,
          licensePlateLabelHidden: isInDashboard,
          stateLabelHidden: isInDashboard,
          makeLabelHidden: isInDashboard,
          modelLabelHidden: isInDashboard,
          trimLabelHidden: isInDashboard,
          formStyle: { margin: FormMargin },
        }}
      />
      {isInHeader && (
        <RecentReportsSuggestions
          reportType="vehicle_report"
          closeForm={closeForm}
        />
      )}
      {fcraLink && (
        <Stack margin={FormMargin}>
          <FcraWarning
            fcraLink={fcraLink}
            tosLink={tosLink}
            brandName={brandName}
          />
        </Stack>
      )}
    </Stack>
  );
}
